'use client';

import dynamic from 'next/dynamic';

const Header = dynamic(() => import('../header/Header'), { ssr: false });
const Footer = dynamic(() => import('../footer/Footer'), { ssr: false });
const Navigation = dynamic(() => import('../navigation/Navigation'), { ssr: false });
const TawkToChat = dynamic(() => import('../TawkToChat/TawkToChat'), { ssr: false });
const FooterHeader = dynamic(() => import('../footerHeader/defaultFooter/FooterHeader'), { ssr: false });
const SideBar = dynamic(() => import('../sideBar/SideBar'), { ssr: false });
const DrawerCart = dynamic(() => import('../drawer/Drawer'), { ssr: false });
const Login = dynamic(() => import('../login/Login'), { ssr: false });
const Register = dynamic(() => import('../register/Register'), { ssr: false });
const TelegramButton = dynamic(() => import('../telegramButton/TelegramButton'), { ssr: false });

export default function DefaultLayout({ children }) {
  return (
    <>
      <Header />
      <Navigation />
      <TawkToChat />
      <TelegramButton />
      <main>{children}</main>
      <FooterHeader />
      <SideBar />
      <DrawerCart />
      <Login />
      <Register />
      <Footer />
    </>
  );
}
